import { OrganismoI } from "interfaces/Organismo";

export interface infoFetchOrganismoI {
  id: number | string;
  nombre: string;
  abreviatura: string;
  descripcion?: string;
}

export class Organismo implements OrganismoI {
  id: number | string;
  nombre: string;
  abreviatura: string;
  descripcion?: string;

  constructor(infoFetch: infoFetchOrganismoI) {
    this.id = infoFetch.id;
    this.nombre = infoFetch.nombre;
    this.abreviatura = infoFetch.abreviatura;
    this.descripcion = infoFetch.descripcion;
  }
}

export const makeOrganismo = (infoFetch: infoFetchOrganismoI) => {
  return new Organismo(infoFetch);
};
